export enum TransactionsColumnNames {
  DateCharged = "dateCharged",
  Event = "event",
  ChargedTo = "chargedTo",
  Description = "description",
  Cost = "cost",
  Status = "status"
}
